export const PROJECT_COMMERCE = 2;
export const PROJECT_GENERAL = 1;